import React, { useRef, useState } from 'react';
import Sketch from '@powerednow/components/Sketch';
import BaseDialog from '@powerednow/components/Dialog/Dialog';
import { CreateExtComponent } from '@powerednow/client-shared/Components/react/React';
import withDataWrapper from 'FieldServices/hooks/withDataWrapper';
import ComponentMask from '@powerednow/components/mask/ComponentMask';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

type ImagePreviewProps = {
    onClose: () => void;
    onSave: (dataURL: string) => Promise<string>;
    src: string;
    canEdit: boolean;
    width?: number;
    height?: number;
}

const useStyles = makeStyles<Theme>(createStyles({
    root: {
        '& .MuiDialogContent-root': {
            display: 'flex',
        },
    },
}));

export function ImagePreview({
    onClose = () => {},
    onSave = () => Promise.resolve(''),
    src,
    canEdit,
    width,
    height,
}: ImagePreviewProps) {
    const [open, setOpen] = useState(true);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const sketchRef = useRef(null);
    const classes = useStyles();

    const handleCloseClick = () => {
        setOpen(false);
        onClose();
    };

    const isSvg = src.split('?')[0].endsWith('.svg');

    const handleSaveClick = async () => {
        setSaving(true);
        const dataURL = await sketchRef.current.getDataURL();
        const result = await onSave(dataURL);
        setSaving(false);
        if (result) {
            handleCloseClick();
        }
    };

    return (
        <BaseDialog
            className={classes.root}
            open={open}
            fullScreen
            onClose={handleCloseClick}
            title={canEdit ? 'Image Edit' : 'Image Preview'}
            showCloseButton={false}
            headerButtonsLeft={[{
                color: 'secondary',
                onClick: handleCloseClick,
                children: 'Close',
            }]}
            headerButtonsRight={canEdit ? [{
                color: 'primary',
                onClick: handleSaveClick,
                children: 'Save',
            }] : []}
        >
            <ComponentMask fullWidth showMask={saving || loading}>
                <Sketch
                    ref={sketchRef}
                    source={isSvg ? src : ''}
                    backgroundImage={isSvg ? '' : src}
                    hideToolbar={!canEdit}
                    width={width}
                    height={height}
                    onBusy={busy => setLoading(busy)}
                />
            </ComponentMask>
        </BaseDialog>
    );
}

export default CreateExtComponent('FieldServices.react.view.ImagePreview', withDataWrapper(ImagePreview));
